module.exports = __webpack_public_path__ + "static/media/fishing-rod.4085e930.svg";